import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button/Button';
import Modal from 'components/Modal/Modal';

import styles from './style.css';


const AdminBannedUserModal = (props) => {
  const { show, close, deleteUser, selectedUser } = props;

  const onDelete = useCallback(() => {
    deleteUser(selectedUser, close);
  }, [close, deleteUser, selectedUser]);

  return (
    <Modal
      background="white"
      close={close}
      show={show}
      size="medium"
    >
      <h5 className={styles.modalTitle}>
        Are you sure you want to delete this entry for user {selectedUser}?
      </h5>
      <div className={styles.buttonWrapper}>
        <Button
          colour="orange"
          label="Cancel"
          onClick={close}
        />
        <Button
          colour="orange"
          label="Yes"
          onClick={onDelete}
        />
      </div>
    </Modal>
  );
};
AdminBannedUserModal.propTypes = {
  close: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
  selectedUser: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
};

export default AdminBannedUserModal;
